import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BroadcastService',
    controller: 'BroadcastHttpService'
};
const methods = [
    'GetSerTerminals',
   
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const BrocastHttpApi = ZJApi.defineNewApi('BrocastHttpApi', factory);

export default BrocastHttpApi;